import { useI18n } from "vue-i18n";
import { fetchUpdateUser } from "@/http/login/login";
import { fetchStudentUpdateStudent } from "@/http/student/login";
export interface LanguageEnum {
  label: string;
  code: string;
  abbreviation: string;
  translateJS_id: string;
  icon: string;
}

export const useLanguageEnum = (): LanguageEnum[] => {
  return [
    {
      label: "中文简体",
      code: "zh_CN",
      abbreviation: "简",
      translateJS_id: "chinese_simplified",
      icon: "https://dreamlab.oss-us-east-1.aliyuncs.com/logo/CN.png"
    },
    {
      label: "中文繁體",
      code: "zh_HK",
      abbreviation: "繁",
      translateJS_id: "chinese_traditional",
      icon: "https://dreamlab.oss-us-east-1.aliyuncs.com/logo/HK.png"
    },
    {
      label: "English",
      code: "en_US",
      abbreviation: "EN",
      translateJS_id: "english",
      icon: "https://dreamlab.oss-us-east-1.aliyuncs.com/logo/US.png"
    },
    {
      label: "Español",
      code: "es_ES",
      abbreviation: "ES",
      translateJS_id: "spanish",
      icon: "https://dreamlab.oss-us-east-1.aliyuncs.com/logo/西班牙.png"
    }
  ];
};

function isSimplifiedChinese() {
  const language = navigator.language;
  return language === "zh-CN";
}

function isTraditionalChinese() {
  const language = navigator.language;
  return language === "zh-TW" || language === "zh-HK";
}

function isEnglish() {
  const language = navigator.language;
  return language.startsWith("en");
}

export const useDefaultLanguage = () => {
  const languages = useLanguageEnum();
  const locale = window.localStorage.getItem("locale");
  const item = languages.find((it) => it.code == locale);
  if (locale && item) {
    return locale;
  }

  // const code = isSimplifiedChinese()
  //   ? "zh_CN"
  //   : isTraditionalChinese()
  //   ? "zh_HK"
  //   : isEnglish()
  //   ? "en_US"
  //   : "zh_CN";

  return "zh_HK";
};

export const getCurrentLanguage = () => {
  return useDefaultLanguage();
};

export const useChangeLanguage = () => {
  const { locale } = useI18n();

  const onContextSelect = async (event: any) => {
    locale.value = event;
    window.localStorage.setItem("locale", event);
    try {
      const params = {
        languageCode: event,
        type: 1
      };
      if (window.localStorage.getItem("accessToken")) {
        const loginType = window.localStorage.getItem("loginType");
        const res =
          loginType == "student"
            ? await fetchStudentUpdateStudent(params)
            : await fetchUpdateUser(params);
      }
    } catch (error) {}
  };
  return {
    onContextSelect,
    locale
  };
};
